export default __webpack_public_path__ + "static/media/eur.72246056.svg";